import type { DriveStep } from 'driver.js';

/** Home V2 首次 Guide 支持的 Agent。 */
export type OnboardingStepTwoAgent = 'novelty-check-report' | 'fto-pro' | 'design-fto';

/** Step 2 公共说明气泡与曝光埋点能力。 */
export interface OnboardingStepTwoGuideService {
    /**
     * 创建当前输入状态对应的 Step 2 Driver 步骤。
     * @param element 需要高亮并保持可交互的稳定目标。
     * @param hasPrefilledInput 当前是否存在注册前带入的问题或图片。
     */
    createStep(element: DriveStep['element'], hasPrefilledInput: boolean): DriveStep;

    /**
     * 上报成功激活的 Step 2 曝光。
     * @param agent 当前实际展示输入引导的 Agent。
     * @param hasPrefilledInput 当前是否进入预填直接提交分支。
     */
    trackSpotlight(agent: OnboardingStepTwoAgent, hasPrefilledInput: boolean): void;
}

/** Step 2 公共引导 service 的容器标识。 */
export const OnboardingStepTwoGuideService = Symbol('OnboardingStepTwoGuideService');
